import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/air-conditioner-btu-calculator',
  component: () => import('../../routes/AirConditionerBtuCalculator.svelte'),
  card: {
    id: 'air-conditioner-btu-calculator',
    title: 'Air Conditioner BTU Calculator',
    description:
      'Size any room or whole house: BTU/hr, tons, and kW using the 20 BTU/sq ft rule with climate, sun, insulation, ceiling-height, occupancy, and kitchen adjustments.',
    icon: 'ac_unit',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/air-conditioner-btu-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Air Conditioner BTU Calculator – Room & Whole-House AC Sizing',
    description:
      'Free air conditioner BTU calculator. Find the right AC size in BTU/hr, tons, or kilowatts using the 20 BTU/sq ft rule plus Manual-J-style climate, sun, insulation, ceiling-height, occupancy, and kitchen adjustments.',
  },
};

export default meta;